import { DefaultService } from '@/services/DefaultService';

export default class ParametrizacaoService extends DefaultService {
    
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(page, limit, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/config/parametrizacoes.json?page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(form) {
        return this._http.post(`${this._env}/config/parametrizacao`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    getConfigByNomeIdusuario(nome, idusuario) {
        // pode-se passar o idusuario como null para buscar a config só da empresa
		return this._http.get(`${this._env}/config/parametrizacao/${nome}/${idusuario}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/config/getcombo/parametrizacao.json?param=${params}`), this._headers).then(res => {
				return res.body;
		}, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
		});
	}

    deleteParametrizacaoUsuario(parametrizacao) {
        return this._http.post(`${this._env}/config/usuario/parametrizacao/delete`, parametrizacao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    corrigeValor(correcao) {
        return this._http.post(`${this._env}/config/parametrizacao/corrigevalor`, correcao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}